import React, { useRef, useState, useEffect } from "react";
import * as ReactKonva from "react-konva";
import EditableLine from "../CreateLocation/EditableLine";
import { Icon } from "@vds/icons";
import MovableToolbar from "../wrapperComponents/MovableToolbar";
import useImage from "use-image";
import { setLocationData } from "../../../store/actions/location";
import { useDispatch } from "react-redux";
import createZone from  "../../../assets/create-zone.svg";

const KonvaImageWrapper = React.memo(
    ({ id, imageUrl, width, height }) => {
        const [image] = useImage(imageUrl);
        return <ReactKonva.Image image={image} width={width} height={height} />;
    },
    (prevProps, nextProps) => prevProps.id === nextProps.id
);

const CanvasWithZoomFullscreen = ({ current_modal, location_data, floorid, floor, zones, isCreatingPolygon, enableCreateButton, newPolygonPoints, setIsCreatingPolygon, setNewPolygonPoints, handleZoneDelete, zone_id, layerRef, handleStageClick }) => {
    const stageRef = useRef(null);
    const containerRef = useRef(null);
    const [scalex, setScalex] = useState(1);
    const [scaley, setScaley] = useState(1);
    const [stageSize, setStageSize] = useState({ width: 580, height: 400 });
    const [isFullscreen, setIsFullscreen] = useState(false);
    const dispatch = useDispatch();

    const isEnabled = () => {
        const addNewZoneButtonClicked = location_data?.addNewZoneButtonClicked;
        const actionTypeAdd = location_data?.action_type?.toLowerCase() === 'add';
        const actionTypeClone = location_data?.cloneAction === true;
        const zoneDeletedInEditMode = location_data?.zoneDeletedInEditMode?.[floorid];
        const editNewFloorUpdated = location_data?.editNewFloorUpdated;
        if (actionTypeAdd) {
            return true;
        } else {
            if (addNewZoneButtonClicked || editNewFloorUpdated || zoneDeletedInEditMode) {
                return true;
            } else {
                return false;
            }
        }
    }

    const sideBarStyle = {
        background: '#fff',
        borderRadius: '16px 16px 0 0',
        // Only left and bottom shadow, with depth effect
        boxShadow: '4px 8px 16px rgba(0,0,0,0.15), -2px 0 8px rgba(0,0,0,0.07)',
        backgroundColor: '#fff',
        cursor: 'pointer',
        padding: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'box-shadow 0.2s',
    }
    // Zoom in
    const handleZoomIn = () => {
        setScalex((s) => Math.min(s + 0.1, 2));
        setScaley((s) => Math.min(s + 0.1, 2));
    };
    // Zoom out
    const handleZoomOut = () => {
        setScalex((s) => Math.max(s - 0.1, 1));
        setScaley((s) => Math.max(s - 0.1, 1));
    };

    useEffect(() => {
        let timer;

        timer = setTimeout(() => {
            if (newPolygonPoints?.length > 0) {
                dispatch(setLocationData({
                    ...location_data,
                    newZones: {
                        ...location_data?.newZones,
                        [floorid]: {
                            zoneAlreadySelected: true,
                            newlyAddedZone: true,
                            zone_id_selected: zone_id
                        }
                    },
                }));
            }
        }, 100);

        return () => clearTimeout(timer);
    }, [newPolygonPoints]);

    // Fullscreen toggle
    const handleFullscreen = () => {
        if (!isFullscreen) {
            // Enter fullscreen
            if (containerRef.current.requestFullscreen) {
                containerRef.current.requestFullscreen();
            } else if (containerRef.current.webkitRequestFullscreen) {
                containerRef.current.webkitRequestFullscreen();
            }
            setScalex(window.innerWidth / stageSize.width);
            setScaley(window.innerHeight / stageSize.height);
            setStageSize({ width: window.innerWidth, height: window.innerHeight });
            setIsFullscreen(true);
        } else {
            // Exit fullscreen
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
            setScalex(1);
            setScaley(1);
            setStageSize({ width: 600, height: 400 });
            setIsFullscreen(false);
        }
    };

    // Listen for fullscreen change to update state
    React.useEffect(() => {
        const onFullscreenChange = () => {
            const fs = document.fullscreenElement || document.webkitFullscreenElement;
            setIsFullscreen(!!fs);
            if (!fs) setStageSize({ width: 600, height: 400 });
        };
        document.addEventListener("fullscreenchange", onFullscreenChange);
        document.addEventListener("webkitfullscreenchange", onFullscreenChange);
        return () => {
            document.removeEventListener("fullscreenchange", onFullscreenChange);
            document.removeEventListener("webkitfullscreenchange", onFullscreenChange);
        };
    }, []);

    return (
        <div ref={containerRef} style={{ position: "relative", background: "#fafafa", border: '1px solid #6F7171', borderRadius: '8px' }}>
            <div style={{ position: 'relative', width: '100%', height: 400 }}>
                {enableCreateButton && <div
                    className='zone-action-buttons'
                    style={{
                        position: 'absolute',
                        right: 0,
                        top: 0,
                        width: '36px',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        zIndex: 1000
                    }}
                >
                    {/* Add your content here */}
                    <MovableToolbar>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                            gap: '0'
                        }}>
                            <div style={{ ...sideBarStyle, borderRadius: '8px 8px 8px 8px' }}
                                onClick={() => handleFullscreen()}
                            >
                                <Icon
                                    name="fullscreen"
                                    size="small"
                                    color={"#000000"}
                                />
                            </div>
                        </div>

                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                            gap: '0'
                        }}>
                            <div style={{ ...sideBarStyle, borderRadius: '8px 8px 0px 0px', backgroundColor: isCreatingPolygon || !isEnabled() ? 'rgb(223 223 223)' : '#fff',
 }}
                                onClick={() => {
                                    if ( newPolygonPoints.length >= 6 || !isEnabled() ) {
                                        return;
                                    }
                                    setIsCreatingPolygon(true);
                                    setNewPolygonPoints([]);
                                    dispatch(setLocationData({
                                        ...location_data,
                                        zoneDeletedInEditMode: {
                                            ...location_data?.zoneDeletedInEditMode,
                                            [floorid]: false,
                                        }
                                    }));
                                }}
                            >
                                <img src={createZone} alt="Create Zone" title="Create Zone" width={16} height={16} />
                                {/* <Icon
                                    name="artboard"
                                    title="Create Zone"
                                    size="small"
                                    color={"#000000"}
                                /> */}
                            </div>
                            <div style={{ ...sideBarStyle, borderRadius: '0px 0px 8px 8px' }}
                                onClick={() => { handleZoneDelete(floorid, location_data?.newZones?.[floorid]?.zone_id_selected); }}
                            >
                                <Icon
                                    name="trash"
                                    size="small"
                                    color={"#000000"}
                                />
                            </div>
                        </div>

                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                            gap: '0'
                        }}>
                            <div style={{ ...sideBarStyle, borderRadius: '8px 8px 0px 0px' }}
                                onClick={() => handleZoomOut()}
                            >
                                <Icon
                                    name="zoom-out"
                                    size="small"
                                    color={"#000000"}
                                />
                            </div>
                            <div style={{ ...sideBarStyle, borderRadius: '0px 0px 8px 8px' }}
                                onClick={() => handleZoomIn()}
                            >
                                <Icon
                                    name="zoom-in"
                                    size="small"
                                    color={"#000000"}
                                />
                            </div>
                        </div>
                    </MovableToolbar>
                </div>}

                <ReactKonva.Stage
                    className={`${current_modal == 'AddZone' || current_modal == 'NewZone' ? 'floor-image-addZone' : 'floor-image'}`}
                    width={stageSize.width}
                    height={stageSize.height}
                    onClick={(e) => handleStageClick(e)}
                    ref={stageRef}
                    scaleX={scalex}
                    scaleY={scaley}
                    draggable = {
                        scalex > 0.9 || scaley > 0.9? true : false
                    }
                    onDragStart={e => {
                        const container = e.target.getStage().container();
                        if(scalex > 1 || scaley > 1){
                        container.style.cursor = 'grabbing';
                        }
                    }}
                    onDragEnd={e => {
                        const container = e.target.getStage().container();
                        if(scalex > 1 || scaley > 1){
                        container.style.cursor = 'default';
                        }
                    }}
                    onMouseEnter={e => {
                        const container = e.target.getStage().container();
                        if(scalex > 1 || scaley > 1){
                        container.style.cursor = 'grab';
                        }
                    }}
                    onMouseLeave={e => {
                        const container = e.target.getStage().container();
                        container.style.cursor = 'default';
                    }}
                >
                    <ReactKonva.Layer ref={layerRef}
                    >
                        {floor?.file instanceof Blob &&
                            <KonvaImageWrapper
                                id={`floor-${floorid}-${floor?.floorImageId}-image`}
                                imageUrl={URL.createObjectURL(floor.file)}
                                width={580}
                                height={360}
                            />
                        }
                        {zones?.map((zone, idx) => {
                            return (zone?.zone_coordinates && Array.isArray(zone?.zone_coordinates)) ? (
                                <EditableLine key={idx} floorKey={floorid} zone_id={zone?.id} enableCreateButton={enableCreateButton} />
                            ) : null;
                        })}
                        
                        {isCreatingPolygon && zone_id && location_data?.newZones?.[floorid]?.newlyAddedZone && (
                            <EditableLine
                                floorKey={floorid} zone_id={zone_id} enableCreateButton={enableCreateButton} createZone={true}
                            />
                        )}
                    </ReactKonva.Layer>
                </ReactKonva.Stage>
            </div>
        </div>
    );
};

export default CanvasWithZoomFullscreen;
